import createReactContext from '@ant-design/create-react-context';
export const FormContext = createReactContext({
    labelAlign: 'right',
    vertical: false,
});
